module.exports = __webpack_public_path__ + "static/media/First floor plan_page-0001 (1).5c9390dc.jpg";